import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import winRateApi from '~/pages/Dashboard/AnalyticsBox/reports/WinRate/winRate.api';
import { PAGINATION_PER_PAGE } from '~/config/constants';
import { handleThunkException } from '~/services/thunk.service';

export const fetchWinRateApi = createAsyncThunk('dashboard/winRate/fetchWinRateApi', async (params, { dispatch }) => {
    try {
        dispatch(requestStarted());
        const data = await winRateApi.getAll(params);
        if (data) {
            dispatch(getRowsPaginated(data.rows));
            dispatch(getTotalRowsNumber(data.totalRows));
            dispatch(changePerPage(params.perPage));
            dispatch(changePage(params.page));
            dispatch(requestFinished());
        }
    } catch (error) {
        handleThunkException(error, dispatch);
    }
});

export const winRateSlice = createSlice({
    name: 'dashboard/winRate',
    initialState: {
        rows: [],
        totalRows: 0,
        perPage: PAGINATION_PER_PAGE,
        page: 1,
    },
    reducers: {
        getRowsPaginated(state, { payload }) {
            return {
                ...state,
                rows: payload,
            };
        },
        getTotalRowsNumber(state, { payload }) {
            return {
                ...state,
                totalRows: payload,
            };
        },
        changePerPage(state, { payload }) {
            return {
                ...state,
                perPage: payload,
            };
        },
        changePage(state, { payload }) {
            return {
                ...state,
                page: payload,
            };
        },
    },
});

export const { getRowsPaginated, getTotalRowsNumber, changePerPage, changePage } = winRateSlice.actions;
